export default "__VITE_ASSET__3079323d__"